/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import District from '../District'
import NewDistrict from '../NewDistrict'
import EditDistrict from '../EditDistrict'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/districts',
    name: 'district',
    component: District,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/districts/create',
    name: 'create-district',
    component: NewDistrict,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/districts/:id/edit',
    name: 'edit-district',
    component: EditDistrict,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/district/routes/index.js